/* eb-product.js — the fit finder, the lineup filter, the gallery and the bundles.

   Four behaviours, one file, because all four are additive: remove this script
   and the fit chart still draws with every model listed and its range printed,
   the lineup shows every bike, the gallery shows its photographs, and the buy
   column adds the bike to the cart at the price the server rendered. Nothing
   here is load-bearing.

   No framework, no build step, no state outside the DOM. Everything these
   behaviours need is already an attribute on the element that needs it, which
   is what lets a section be duplicated in the editor and simply work. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ── the fit finder ──────────────────────────────────────────────────────
     One number moves everything: the reading, the line across the bands, which
     bands light, which cards show. A band out of range dims, never disappears —
     a rider at 163 cm should be able to see what they have just ruled out. The
     cards below answer only "which ones can I ride", so the ones that do not fit
     are taken out of that list; without this script every card is listed.

     −/+ 按钮一次走 1 cm：手机上拖滑块很难停在一个准确的数。
     编辑器里重新加载这个分区时（shopify:section:load）也要重新绑定，原来只在页面加载时绑一次。 */
  function fitFinder(box) {
    var input = $('[data-eb-fit-input]', box);
    if (!input || box.ebFit) return;
    box.ebFit = true;
    var read = $('[data-eb-fit-read]', box),
        note = $('[data-eb-fit-note]', box),
        bands = $$('.eb-fitlane[data-min]', box),
        rows = $$('.eb-fitresult', box),
        track = $('[data-eb-fit-track]', box),
        still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    var moved = false, lit = null;

    /* On a phone the results are a horizontal track. The lit bike is scrolled
       to the middle of it — the TRACK scrolls, never the page, so a thumb on
       the slider does not get yanked down to the cards. */
    function centre(el) {
      if (!track || !el || track.scrollWidth <= track.clientWidth + 1) return;
      var left = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: (moved && !still) ? 'smooth' : 'auto' });
    }
    function inRange(el, h) {
      var lo = +el.dataset.min, hi = +el.dataset.max;
      return lo > 0 && hi > 0 && h >= lo && h <= hi;
    }

    function paint() {
      var h = +input.value, lo = +input.min, hi = +input.max;
      input.style.setProperty('--fill', ((h - lo) / (hi - lo) * 100) + '%');
      box.style.setProperty('--h', h);
      if (read) read.textContent = h;

      /* THE HEIGHT IS REMEMBERED, and only once it has been MOVED. An untouched
         slider is the setting's default, not an opinion about anybody's height.
         The review section reads this key; it never leaves the browser. */
      if (moved) { try { localStorage.setItem('eb-fit-height', String(h)); } catch (e) {} }

      bands.forEach(function (b) { b.classList.toggle('is-on', inRange(b, h)); });

      var fits = [];
      rows.forEach(function (r) {
        var ok = inRange(r, h);
        r.classList.toggle('is-out', !ok);
        r.classList.toggle('is-edge', ok && (h === +r.dataset.min || h === +r.dataset.max));
        r.classList.remove('is-on');
        if (ok) fits.push({ el: r, off: Math.abs(h - (+r.dataset.min + +r.dataset.max) / 2) });
      });
      fits.sort(function (a, b) { return a.off - b.off; });
      if (fits.length) fits[0].el.classList.add('is-on');
      var best = fits.length ? fits[0].el : null;
      if (best && best !== lit) centre(best);
      lit = best;

      if (note && note.dataset.one) {
        var icon = note.querySelector('svg');
        var text = fits.length
          ? (fits.length === 1 ? note.dataset.one : note.dataset.some.replace('{{ count }}', fits.length))
          : note.dataset.none;
        note.textContent = '';
        if (icon) note.appendChild(icon);
        note.appendChild(document.createTextNode(text.replace('{{ height }}', h)));
      }
    }
    input.addEventListener('input', function () { moved = true; paint(); });
    $$('[data-eb-fit-step]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = Math.min(+input.max, Math.max(+input.min, +input.value + +btn.dataset.ebFitStep));
        if (v === +input.value) return;
        input.value = v; moved = true; paint();
      });
    });
    paint();
  }
  $$('[data-eb-fit]').forEach(fitFinder);
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-eb-fit]', e.target).forEach(fitFinder);
  });

  /* ── the lineup tabs ─────────────────────────────────────────────────────
     Each Category is its own panel with its own rail and its own cards per
     view, so a pill shows a panel rather than filtering one long rail. The
     panel that appears starts at its first card, and the rail is told to
     measure again: a rail measured while hidden has no width and believes it
     has nothing to scroll. */
  function lineup(box) {
    var tabs = $('.eb-lineup__tabs', box);
    if (!tabs || box.ebLineup) return;
    box.ebLineup = true;

    function show(id) {
      $$('.eb-pill[data-panel]', tabs).forEach(function (x) {
        var on = x.dataset.panel === id;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      $$('[data-eb-lineup-panel]', box).forEach(function (p) {
        p.hidden = p.dataset.ebLineupPanel !== id;
        if (!p.hidden) { var r = $('.eb-rail', p); if (r) r.scrollLeft = 0; }
      });
      window.dispatchEvent(new Event('resize'));
    }
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('.eb-pill[data-panel]');
      if (b) show(b.dataset.panel);
    });
    /* In the editor, picking a Category block opens its panel. */
    document.addEventListener('shopify:block:select', function (e) {
      var b = e.target.closest && e.target.closest('.eb-pill[data-panel]');
      if (b && tabs.contains(b)) show(b.dataset.panel);
    });
  }
  $$('[data-eb-lineup]').forEach(lineup);
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-eb-lineup]', e.target).forEach(lineup);
  });

  /* ── the gallery ─────────────────────────────────────────────────────────
     Two frames, one at a time, and a thumbnail strip inside the photographs
     one. The model frame is Shopify's own, which reveals on interaction — so
     nothing is fetched until the visitor asks for it. */
  $$('[data-eb-pgal]').forEach(function (box) {
    var modes = $('.eb-pgal__modes', box);
    if (modes) {
      modes.addEventListener('click', function (e) {
        var b = e.target.closest('.eb-pgal__mode');
        if (!b) return;
        $$('.eb-pgal__mode', box).forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('.eb-pgal__frame', box).forEach(function (f) { f.hidden = f.dataset.pane !== b.dataset.mode; });
      });
    }

    var thumbs = $('.eb-pgal__thumbs', box);
    if (!thumbs) return;
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.eb-pgal__thumb');
      if (!b) return;
      $$('.eb-pgal__thumb', thumbs).forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var id = b.dataset.ebThumb;
      $$('.eb-pgal__slide', box).forEach(function (s) {
        s.classList.toggle('is-on', s.dataset.ebSlide === id);
      });
    });
  });

  /* ── the variant picker ──────────────────────────────────────────────────
     Resolves a combination against the catalogue the section printed, so no
     round trip and no flash of the wrong price. The URL is updated with
     replaceState: a share of this page should land on this colour. */
  $$('[data-eb-product]').forEach(function (root) {
    var form = $('form[data-eb-add]', root);
    var data = $('[data-eb-variants]', root);
    if (!form || !data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }
    var idField = $('[data-eb-variant-id]', form);
    var priceBox = $('[data-eb-price]', root);
    var stockBox = $('[data-eb-stock]', root);
    var button = $('[data-eb-atc-button]', form);

    /* 预售：每个子体的发货日在 [data-eb-ships]（子体 id → YYYY-MM-DD，不是预售为空）。
       服务器按它那天判断过一次，但页面会被缓存，所以这里按访客今天再判断：日期过了就当现货。 */
    var shipsMap = {};
    var shipsEl = $('[data-eb-ships]', root);
    if (shipsEl) { try { shipsMap = JSON.parse(shipsEl.textContent) || {}; } catch (err) {} }
    var preBox = $('[data-eb-preorder]', root);
    var preNote = $('[data-eb-preorder-note]', root);
    var preProp = $('[data-eb-ships-prop]', form);
    function todayIso() {
      var d = new Date();
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }
    function shipsOf(v) {
      var d = v && shipsMap[v.id];
      return d && v.available && d > todayIso() ? d : '';
    }
    function lang() { var l = document.documentElement.lang || 'en'; return l === 'en' ? 'en-GB' : l; }
    function asDate(iso) { var p = iso.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
    function addWorkdays(d, n) {
      var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
      return r;
    }
    function paintPre(v) {
      var iso = shipsOf(v);
      var fmt = new Intl.DateTimeFormat(lang(), { weekday: 'short', day: 'numeric', month: 'short' });
      if (preBox) {
        preBox.hidden = !iso;
        if (iso) {
          var d = asDate(iso);
          var ship = $('[data-eb-preorder-ship]', preBox);
          if (ship) ship.textContent = (preBox.dataset.shipTpl || '').replace('%date%', fmt.format(d));
          var arrive = $('[data-eb-preorder-arrive]', preBox);
          var min = parseInt(preBox.dataset.min, 10) || 0, max = parseInt(preBox.dataset.max, 10) || 0;
          if (arrive) {
            if (max) {
              var short = new Intl.DateTimeFormat(lang(), { day: 'numeric', month: 'short' });
              var a = addWorkdays(d, Math.max(min, 1)), b = addWorkdays(d, Math.max(max, 1));
              var range = a.getTime() === b.getTime() ? short.format(b)
                : (short.formatRange ? short.formatRange(a, b) : short.format(a) + ' – ' + short.format(b));
              arrive.textContent = (preBox.dataset.arriveTpl || '').replace('%date%', range);
              arrive.hidden = false;
            } else {
              arrive.hidden = true;
            }
          }
        }
      }
      if (stockBox) stockBox.hidden = !!iso;
      if (preNote) {
        preNote.hidden = !iso;
        if (iso) preNote.textContent = (preNote.dataset.tpl || '').replace('%date%', fmt.format(asDate(iso)));
      }
      if (preProp) {
        preProp.disabled = !iso;
        preProp.value = iso ? new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(asDate(iso)) : '';
      }
      if (button && v && v.available) {
        var label = iso ? button.dataset.preorder : button.dataset.add;
        if (label) button.textContent = label;
      }
      hintWarehouses();
    }

    /* 仓库按钮下面一行小字：这个仓库（配当前选中的其他选项）哪天发货；不是预售就不写 */
    function hintWarehouses() {
      if (!Object.keys(shipsMap).some(function (k) { return shipsMap[k]; })) return;
      var values = chosen();
      $$('[data-eb-option]', form).forEach(function (g, gi) {
        $$('[data-eb-value]', g).forEach(function (btn) {
          if (btn.classList.contains('eb-swatch')) return;
          var probe = values.slice();
          probe[gi] = btn.dataset.ebValue;
          var iso = shipsOf(match(probe));
          var hint = $('.eb-option__ships', btn);
          if (!iso) { if (hint) hint.remove(); return; }
          if (!hint) { hint = document.createElement('small'); hint.className = 'eb-option__ships'; btn.appendChild(hint); }
          var short = new Intl.DateTimeFormat(lang(), { day: 'numeric', month: 'short' });
          var tpl = (preBox && preBox.dataset.shortTpl) || '%date%';
          hint.textContent = tpl.replace('%date%', short.format(asDate(iso)));
        });
      });
    }

    function chosen() {
      return $$('[data-eb-option]', form).map(function (g) {
        var picked = $('[aria-checked="true"]', g);
        return picked ? picked.dataset.ebValue : null;
      });
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== null && v.options[j] !== values[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* A combination the shop does not sell is marked, not hidden. Hiding it
       makes the picker change shape under the reader's hand. */
    function markAvailability(values) {
      $$('[data-eb-option]', form).forEach(function (g, gi) {
        $$('[data-eb-value]', g).forEach(function (btn) {
          var probe = values.slice();
          probe[gi] = btn.dataset.ebValue;
          var v = match(probe);
          btn.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function apply(v) {
      if (idField && v) idField.value = v.id;
      if (priceBox && v) {
        var now = $('.eb-price__now', priceBox);
        var was = $('.eb-price__was', priceBox);
        if (now) now.textContent = window.ebMoney ? window.ebMoney(v.price) : now.textContent;
        if (was) was.hidden = !(v.compare_at_price > v.price);
      }
      if (stockBox && v) {
        stockBox.className = 'eb-stock eb-stock--' + (v.available ? 'in' : 'out');
        stockBox.textContent = v.available ? (stockBox.dataset.in || stockBox.textContent)
                                           : (stockBox.dataset.out || stockBox.textContent);
      }
      if (button && v) {
        button.disabled = !v.available;
        var label = v.available ? button.dataset.add : button.dataset.soldOut;
        if (label) button.textContent = label;
      }
      paintPre(v);
      if (v && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('eb:variant', { detail: { variant: v } }));
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-eb-value]');
      if (!btn) return;
      var group = btn.closest('[data-eb-option]');
      $$('[data-eb-value]', group).forEach(function (x) {
        x.setAttribute('aria-checked', x === btn ? 'true' : 'false');
      });
      var head = $('[data-eb-option-value]', group);
      if (head) head.textContent = btn.dataset.ebValue;
      var values = chosen();
      markAvailability(values);
      apply(match(values));
    });

    markAvailability(chosen());
    paintPre(match(chosen()));
  });

  /* ── the bundles ─────────────────────────────────────────────────────────
     THE BIKE'S PRICE NEVER MOVES. Only the total and the saving do, and both
     are computed from the same attributes the server printed, so the figure
     before this file runs — the bike alone — is the honest one.

     A checkbox row states aria-pressed and a radio row states aria-checked.
     They are different controls and must not claim to be the same one, so the
     total asks for whichever the row actually carries. */
  $$('[data-eb-addons]').forEach(function (box) {
    var base = +box.dataset.base || 0;
    var totalEl = $('[data-eb-addons-total]', box);
    var saveEl = $('[data-eb-addons-save]', box);
    var root = box.closest('[data-eb-product]') || document;

    function on(el) {
      return el.getAttribute('aria-pressed') === 'true' || el.getAttribute('aria-checked') === 'true';
    }
    function money(cents) {
      if (window.ebMoney) return window.ebMoney(cents);
      return (cents / 100).toFixed(cents % 100 ? 2 : 0);
    }
    function picked() {
      return $$('[data-eb-addon]', box).filter(function (it) { return on(it) && !it.disabled; });
    }
    /* The saving is the row's own data-save — the amount the bundle_offer
       states for this currency, which the Discount Function takes off too.
       Nothing here works a discount out; a gift's data-save is its price. */
    function calc() {
      var sum = base, saved = 0;
      picked().forEach(function (it) {
        var p = +it.dataset.price || 0, s = Math.min(+it.dataset.save || 0, p);
        sum += p - s;
        saved += s;
      });
      if (totalEl) totalEl.textContent = money(sum);
      if (saveEl) saveEl.textContent = saved ? (saveEl.dataset.word || '').replace('{{ amount }}', money(saved)) : '';
      /* 标签版 Bundles 的角标、赠品摘要、底部件数跟着刷新（snippets/product-bundles 底部的脚本听这个）。 */
      box.dispatchEvent(new CustomEvent('eb:addons:change', { bubbles: true }));
    }

    box.addEventListener('click', function (e) {
      var head = e.target.closest('.eb-addons__head');
      if (head) {
        var group = head.closest('.eb-addons__group');
        var open = group.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      var it = e.target.closest('[data-eb-addon]');
      /* A gift is ticked by the bike; a sold-out accessory cannot be ticked. */
      if (!it || it.disabled || it.hasAttribute('data-locked')) return;
      var g = it.closest('.eb-addons__group');
      if (g.classList.contains('eb-addons__group--radio')) {
        $$('[data-eb-addon]', g).forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        it.setAttribute('aria-checked', 'true');
      } else {
        it.setAttribute('aria-pressed', on(it) ? 'false' : 'true');
      }
      calc();
    });

    /* The add-ons ride along with the bike as extra cart lines. eb-cart.js
       already knows how to send them and how to write the bike's title onto
       each one, so this only has to say which. A row with no variant — the
       cover every bike already has — adds nothing. */
    var form = $('form[data-eb-add]', root);
    if (form) {
      form.addEventListener('submit', function () {
        var items = picked().filter(function (it) { return it.dataset.variant; })
          .map(function (it) { return { id: it.dataset.variant, quantity: 1 }; });
        if (items.length) {
          document.dispatchEvent(new CustomEvent('eb:cart:extras', { detail: { items: items } }));
        }
      }, true);
    }

    /* 带子体的配件换了款式 / 尺码后，snippets/product-bundles 底部的脚本改完行上的
       data-price，再发这个事件让总价重算一次。 */
    box.addEventListener('eb:addons:recalc', calc);

    calc();
  });

  /* ══ THE RATING'S LINK ═════════════════════════════════════════════════
     The count under the subtitle jumps to the reviews section. If the shop has
     not put one on this template there is nothing to jump to, so the href
     comes off and the count reads as what it is — a number. An <a> without an
     href is not focusable and not announced as a link, which is exactly right:
     nothing is offered that cannot be done. */
  var rateLink = $('[data-eb-rate-link]');
  if (rateLink) {
    var target = rateLink.getAttribute('href');
    if (!target || !document.querySelector(target)) rateLink.removeAttribute('href');
  }

  /* ══ THE BUY BAR ═══════════════════════════════════════════════════════
     Two jobs, and the second is the reason it exists. The first is obvious:
     once the real Add to cart has scrolled away, offer it again. The second
     is that a product page eleven bands long has no way back to any of them
     — so the bar carries the page's own table of contents and lights the
     band you are in.

     IT APPEARS WHEN THE REAL BUTTON LEAVES, never on load: a bar that is
     there before the visitor has seen the price arrived before the question.
     An observer on the button itself rather than a scroll threshold, because
     a threshold is different on every template and wrong on every phone. */
  function buybar() {
  var bar = $('[data-eb-buybar]');
  /* Once per bar, and again for the bar the editor puts in its place: a
     re-rendered section is a NEW element, and the controller's observers and
     its --buybar-top were all attached to the old one. That is what left the
     bar sitting on the header in the customiser. */
  if (bar && bar.ebBarBound) return;
  if (bar) bar.ebBarBound = true;
  if (bar && 'IntersectionObserver' in window) {
    var watch = $('[data-eb-buybar-watch]') || $('[data-eb-atc-button]');
    /* The bar's own height, published, because the anchors need it: a stop
       jumped to while the bar is showing has to land BELOW the bar, and the
       bar is 69px on a desktop and 100px on a phone. Measured, not guessed —
       and only while it is on, so a page without the bar keeps its old
       scroll-margin exactly. */
    var publishBarHeight = function () {
      document.documentElement.style.setProperty('--buybar-h',
        (bar.classList.contains('is-on') ? Math.round(bar.offsetHeight) : 0) + 'px');
    };
    if (watch) {
      /* PAST IT, not merely off screen. Off screen is also true before the
         visitor has reached it — which on a phone is the moment the page
         opens — so the bar is on only while the marker is ABOVE the top. */
      new IntersectionObserver(function (rows) {
        var r = rows[0];
        var top = r.rootBounds ? r.rootBounds.top : 0;
        bar.classList.toggle('is-on', !r.isIntersecting && r.boundingClientRect.top < top);
        publishBarHeight();
      }).observe(watch);
    }
    window.addEventListener('resize', publishBarHeight);
    window.addEventListener('load', publishBarHeight);
    publishBarHeight();

    /* IT FOLLOWS THE HEADER'S REAL EDGE. Below 1080px the header hides on
       scroll-down — exactly when this bar arrives — so a bar pinned to the
       header's RESTING height sits 77px down with the page showing through
       the gap above it. Measured on a 390px frame; it is the thing that made
       the bar look like it was floating rather than fixed to the top.

       The header's bottom is the honest number in every state: showing,
       hidden, or mid-transition. Written on the same rAF the scroll already
       costs, and only while the bar is on. */
    var site = document.querySelector('[data-eb-header]');
    if (site) {
      var pending = false;
      var follow = function () {
        pending = false;
        var edge = Math.max(0, Math.round(site.getBoundingClientRect().bottom));
        bar.style.setProperty('--buybar-top', edge + 'px');
      };
      var queue = function () {
        if (!pending) { pending = true; requestAnimationFrame(follow); }
      };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      window.addEventListener('load', follow);

      /* AND WHILE THE HEADER IS MOVING, which is not while the page is
         scrolling. Scrolling up unhides the header, the header takes its
         transition to slide back down, and no scroll event fires during it —
         so the last measurement was taken mid-slide and the bar sat 3px OVER
         the header until the next scroll. Measured at 390. A frame loop for
         the length of the transition, and only for that. */
      var chasing = false;
      var chase = function (e) {
        if (e && e.target !== site) return;
        if (chasing) return;
        chasing = true;
        (function step() { follow(); if (chasing) requestAnimationFrame(step); }());
      };
      var stop = function (e) {
        if (e && e.target !== site) return;
        chasing = false; follow();
      };
      site.addEventListener('transitionrun', chase);
      site.addEventListener('transitionend', stop);
      site.addEventListener('transitioncancel', stop);
      follow();
    }

    /* The rail is a scrollspy over the anchors the page already declares. It
       reads them out of the DOM rather than from a list in a setting: a
       second list of the sections is a second thing to keep in step.

       IT IS ALSO BUILT FROM THEM. section-shell prints an .eb-anchor for
       every band that has been given an Anchor, labelled with that band's
       own heading, so the rail is whatever the page currently is — reorder
       the sections in the editor and the rail reorders with them, remove one
       and its stop goes with it. A merchant who has not set an Anchor gets
       no stop, which is the honest answer: there is nowhere to send them. */
    var nav = $('.eb-buybar__nav', bar);
    var main = document.getElementById('MainContent') || document;

    /* THE SPEC SHEET IS THE SHORTCUT, NOT A STOP. It is the one band that is
       already named on the bar — beside the button, with its own icon — so
       printing "Specs" again as the first stop said the same word twice, two
       inches apart. The sheet is found by its own markup and the shortcut is
       pointed at its anchor, which means the two cannot drift apart and no
       setting has to name it. */
    var sheet = $('[data-eb-specsheet]');
    var sheetSection = sheet && sheet.closest('.eb-section');
    var sheetAnchor = sheetSection && $('.eb-anchor[id]', sheetSection);
    var shortcut = $('[data-eb-buybar-specs]', bar);
    if (shortcut) {
      if (sheetAnchor) { shortcut.href = '#' + sheetAnchor.id; shortcut.hidden = false; }
      else shortcut.hidden = true;
    }

    if (nav && !nav.children.length) {
      $$('.eb-anchor[id]', main).forEach(function (t) {
        if (bar.contains(t) || t === sheetAnchor) return;
        var a = document.createElement('a');
        a.className = 'eb-buybar__link';
        a.href = '#' + t.id;
        a.setAttribute('data-eb-buybar-link', '');
        /* Named after the anchor unless the section said otherwise: "closeup"
           reads "Closeup". Short by construction, and the same word the
           address bar shows when you land there. */
        a.textContent = t.getAttribute('data-anchor-label') ||
          t.id.replace(/[-_]+/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); });
        nav.appendChild(a);
      });
    }
    var links = $$('[data-eb-buybar-link]', bar);
    /* Observe the SECTION, not the anchor. The anchor target is a zero-height
       element — with a -45%/-45% root margin the observer's live band is the
       middle tenth of the viewport, and a 0px line crosses that in one frame
       or misses it entirely. Measured: the lit stop never moved. The section
       around it is tall enough to sit in the band the whole time it is being
       read, which is the question the rail is answering. */
    var targets = links.map(function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      return t ? (t.closest('.eb-section') || t) : null;
    });
    if (links.length) {
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var spy = new IntersectionObserver(function (rows) {
        rows.forEach(function (row) {
          if (!row.isIntersecting) return;
          var i = targets.indexOf(row.target);
          if (i < 0) return;
          links.forEach(function (a, n) { a.classList.toggle('is-on', n === i); });
          /* Keep the lit stop in view — a table of contents that marks a
             place off the edge of its own scroller has marked nothing. */
          var a = links[i];
          if (a && nav) {
            var l = a.offsetLeft - nav.offsetLeft;
            if (l < nav.scrollLeft || l > nav.scrollLeft + nav.clientWidth - a.offsetWidth) {
              nav.scrollTo({ left: Math.max(0, l - 24), behavior: smooth ? 'smooth' : 'auto' });
            }
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      targets.forEach(function (t) { if (t) spy.observe(t); });
    }
  }
  }
  buybar();
  document.addEventListener('shopify:section:load', buybar);

  /* ── the fit gate ────────────────────────────────────────────────────────
     An accessory page answers one question and it answers it above the button:
     the last thing a person looks at before pressing is where a return is
     prevented, not a specification table further down. The verdicts are drawn
     by Liquid, one per bike, all hidden but the one that is chosen — so with
     this script removed the page still says which bikes it fits, in the row
     that starts visible, and the button still adds it to the cart.

     THREE THINGS HAPPEN ON A PICK, and only the first is cosmetic:

       1 · the matching answer is shown and the rest are hidden;
       2 · on a NO the button stands down — accent to outline, and Buy it now
           goes away. It is never DISABLED: the picker holds what the visitor
           SAID, not something the shop verified, and they may be buying for
           another bike or as a present. But leaving the loudest thing on the
           page shouting BUY on the line under "it does not fit" is the page
           arguing with itself;
       3 · `eb:fit:pick` goes up the document, so the reviews band can put the
           people who fitted it to the same bike first.

     AND THE PICK IS REMEMBERED, the way the fit finder's height is. Somebody
     shopping for a rack and then a lock is riding the same bike both times;
     asking twice is asking them to do the shop's filing. */
  var BIKE_KEY = 'eb-fit-bike';

  function rememberedBike() {
    try { return localStorage.getItem(BIKE_KEY) || ''; } catch (e) { return ''; }
  }

  function fitgate(box) {
    var pick = $('[data-eb-fitgate-pick]', box);
    if (!pick) return;
    var atc = $('[data-eb-fitgate-atc]', box),
        now = $('[data-eb-fitgate-now]', box),
        answers = $$('.eb-fitgate__ans', box);

    function show(value) {
      var state = '';
      answers.forEach(function (a) {
        var on = a.getAttribute('data-ans') === value;
        a.hidden = !on;
        if (on) state = a.getAttribute('data-state') || '';
      });
      /* Nothing matched — a remembered bike this product has no verdict for.
         Fall back to the row the page loaded with rather than to no answer. */
      if (!state && !answers.some(function (a) { return !a.hidden; })) {
        answers.forEach(function (a) { a.hidden = a.getAttribute('data-ans') !== 'none'; });
      }
      var bad = state === 'no';
      if (atc) {
        atc.classList.toggle('eb-btn--primary', !bad);
        atc.classList.toggle('eb-btn--outline', bad);
      }
      if (now) now.hidden = bad;
      document.dispatchEvent(new CustomEvent('eb:fit:pick', {
        bubbles: true, detail: { value: value, state: state }
      }));
    }

    /* 2026-10：选车框从原生 <select> 换成主题自己的选择器（details + 一行行单选，
       和国家选择器同一个组件）。值从选中的那个单选读；记住的车由脚本勾上时不会触发
       change，所以触发器上的文字在这里自己写。
       一行带 data-variant（Fitment rule 里填了 variant）时，顺手把规格选择器切到那个子款式：
       按子款式的选项值去点规格选择器里对应的按钮，价格、库存、加购的 id 都由规格选择器自己更新。 */
    function radioFor(value) {
      return $$('input[type="radio"]', pick).filter(function (r) { return r.value === value; })[0];
    }
    function label(radio) {
      var out = $('[data-eb-picker-value]', pick);
      var name = radio && radio.closest('.eb-menu__row') && $('.eb-menu__name', radio.closest('.eb-menu__row'));
      if (out && name) out.textContent = name.textContent.trim();
    }
    function pickVariant(id) {
      if (!id) return;
      var root = box.closest('[data-eb-product]') || document;
      var data = $('[data-eb-variants]', root), list;
      try { list = JSON.parse(data.textContent); } catch (e) { return; }
      var v = list.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      $$('[data-eb-option]', root).forEach(function (g, i) {
        var btn = $$('[data-eb-value]', g).filter(function (b) { return b.dataset.ebValue === v.options[i]; })[0];
        if (btn && btn.getAttribute('aria-checked') !== 'true') btn.click();
      });
    }
    function choose(radio) {
      var v = radio.value;
      try {
        if (v && v !== 'none' && v !== 'other') localStorage.setItem(BIKE_KEY, v);
        else if (v === 'none') localStorage.removeItem(BIKE_KEY);
      } catch (e) {}
      show(v);
      pickVariant(radio.getAttribute('data-variant'));
    }

    pick.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) choose(e.target);
    });

    var had = rememberedBike();
    var hadRadio = had && radioFor(had);
    if (hadRadio) {
      hadRadio.checked = true;
      label(hadRadio);
      choose(hadRadio);
    }
  }

  /* ── the same gate, over a grid ──────────────────────────────────────────
     The product page asks above the button; the collection asks above the grid
     and answers on every card. The verdicts are already on the card as
     `data-fits` — a list of the bike ids it goes on — so nothing is fetched and
     nothing is filtered server-side.

     THREE RULES, and they are the ones the whole shop follows:
       · say what was applied, and keep BOTH numbers on screen;
       · DIM, do not hide — a card vanishing from a grid reads as a bug, and
         somebody who has just ruled out a lock should see what they ruled out;
       · hide only when asked, and then print the number hidden with one press
         to bring them back.

     A card with no `data-fits` has no verdicts at all — a bell, a bottle — and
     is never marked and never dimmed. */
  function collectionGate(box) {
    var pick = $('[data-eb-gate-pick]', box);
    if (!pick) return;
    var only = $('[data-eb-gate-only]', box),
        titleEl = $('[data-eb-gate-title]', box),
        whyEl = $('[data-eb-gate-why]', box),
        nEl = $('[data-eb-gate-n]', box);

    var T = function (k) { return box.getAttribute('data-t-' + k) || ''; };

    /* The grid it answers for, not every card on the page: the accessory rail
       further down is a suggestion, not a result, and counting it made "[n] of
       [total]" describe cards that are not in the collection's grid. */
    function cards() {
      return $$('[data-eb-pcard]').filter(function (c) { return !c.closest('.eb-rail'); });
    }

    function apply() {
      var v = pick.value, name = '';
      var opt = pick.options[pick.selectedIndex];
      if (opt) name = opt.textContent.trim();
      var hiding = !!(only && only.getAttribute('aria-pressed') === 'true');
      var all = cards(), fit = 0, unfit = 0;

      all.forEach(function (c) {
        var list = c.getAttribute('data-fits');
        /* No attribute: no verdicts, universal — never marked, never dimmed,
           counted as fitting. An EMPTY attribute is different: every verdict
           is `no`, so it fits none of them. Only a missing attribute is null. */
        var bad = !!(v && v !== 'none' && list !== null &&
                     (',' + list + ',').indexOf(',' + v + ',') < 0);
        c.classList.toggle('eb-pcard--unfit', bad);
        c.hidden = bad && hiding;
        if (bad) { unfit++; } else { fit++; }

        var chip = $('[data-eb-gate-chip]', c);
        if (bad && !chip) {
          var slot = $('.eb-pcard__badges', c);
          if (slot) {
            chip = document.createElement('span');
            chip.className = 'eb-badge';
            chip.setAttribute('data-eb-gate-chip', '');
            slot.insertBefore(chip, slot.firstChild);
          }
        }
        if (chip) {
          if (bad) chip.textContent = T('chip').replace('[bike]', name);
          else chip.remove();
        }
      });

      var picked = v && v !== 'none';
      if (only) only.hidden = !picked;
      if (nEl) {
        nEl.hidden = !picked;
        nEl.textContent = fit + ' / ' + all.length;
      }
      box.classList.toggle('eb-rvmatch--off', !picked);
      if (titleEl) {
        titleEl.textContent = picked
          ? T('matched').replace('[n]', fit).replace('[total]', all.length)
              .replace('[bike]', name)
          : T('ask');
      }
      if (whyEl) {
        whyEl.textContent = !picked ? T('why')
          : (hiding ? T('hidden').replace('[n]', unfit) : T('why'));
      }
    }

    pick.addEventListener('change', function () {
      try {
        if (pick.value && pick.value !== 'none') localStorage.setItem(BIKE_KEY, pick.value);
        else localStorage.removeItem(BIKE_KEY);
      } catch (e) {}
      apply();
    });

    if (only) only.addEventListener('click', function () {
      var on = only.getAttribute('aria-pressed') === 'true';
      only.setAttribute('aria-pressed', on ? 'false' : 'true');
      apply();
    });

    var had = rememberedBike();
    if (had && pick.querySelector('option[value="' + had + '"]')) pick.value = had;
    apply();
  }

  $$('[data-eb-collection-gate]').forEach(collectionGate);
  $$('[data-eb-fitgate]').forEach(fitgate);
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-eb-fitgate]', e.target).forEach(fitgate);
    $$('[data-eb-collection-gate]', e.target).forEach(collectionGate);
  });

}());
